import {
  FETCH_USERNAMES_INFO,
  FETCH_USERNAMES_INFO_SUCCESS,
  FETCH_USERNAMES_INFO_FAILED
} from "../actions/types";
import { ProfileInfo } from "./ProfileReducers";

export interface UserNamesInterface {
  errorFetching: string;
  loading: boolean;
  info?: {
    [key: string]: ProfileInfo;
  };
}

export interface userNamesActionInterface {
  type: string;
  payload?: ProfileInfo;
}

const INITIAL_STATE: UserNamesInterface = {
  errorFetching: "",
  loading: false,
  info: undefined
};

const usernames = (state = INITIAL_STATE, action: userNamesActionInterface) => {
  const oldInfo = { ...state.info };
  switch (action.type) {
    case FETCH_USERNAMES_INFO:
      return {
        ...state,
        loading: true
      };
    case FETCH_USERNAMES_INFO_SUCCESS:
      if (action.payload) {
        return {
          ...state,
          loading: false,
          errorFetching: "",
          info: { ...oldInfo, [action.payload.username]: action.payload }
        };
      }
      break;
    case FETCH_USERNAMES_INFO_FAILED:
      return {
        ...state,
        loading: false,
        errorFetching: ""
      };
    default:
      return state;
  }
};

export default usernames;
